import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getDataAPI } from "../../../services/apiWrapper";

/**
 * LMS - Part 11: a small LMS summary block for the admin dashboard.
 *
 * Council sees whole-LMS totals; a Faculty sees the figures for the courses
 * assigned to them (incl. results waiting to be published). The server decides
 * which view from the token, so this one component serves both.
 */
export default function DashboardSummary() {
  const dispatch = useDispatch();
  const [d, setD] = useState(null);

  useEffect(() => {
    dispatch(getDataAPI("admin/lms/dashboard", localStorage.getItem("adminToken")))
      .then((res) => setD(res.data.data))
      .catch(() => setD(null));
  }, []);

  if (!d) return null;

  const Card = ({ label, value, to }) => (
    <div className="col-md-3 col-6 mb-3">
      <div style={{ background: "#fff", border: "1px solid #e3e6ef", borderRadius: 8, padding: 16, textAlign: "center" }}>
        <div style={{ fontSize: 26, fontWeight: 700 }}>{value}</div>
        <div className="text-muted" style={{ fontSize: 13 }}>{label}</div>
        {to && <div style={{ marginTop: 6 }}><Link to={to} style={{ fontSize: 12 }}>Open →</Link></div>}
      </div>
    </div>
  );

  return (
    <div className="col-12" style={{ marginBottom: 10 }}>
      <h5 style={{ margin: "4px 0 12px" }}>LMS Overview</h5>
      <div className="row">
        {d.is_faculty ? (
          <>
            <Card label="My Courses" value={d.courses} to="/admin/lms/content" />
            <Card label="Students" value={d.students} to="/admin/lms/reports" />
            <Card label="Exams" value={d.exams} to="/admin/lms/exams" />
            <Card label="Results to Publish" value={d.pending_results} to="/admin/lms/results" />
          </>
        ) : (
          <>
            <Card label="Faculty" value={d.faculty} to="/admin/lms/faculty" />
            <Card label="LMS Exams" value={d.exams} to="/admin/lms/exams" />
            <Card label="Exam Attempts" value={d.attempts} to="/admin/lms/reports" />
            <Card label="Results to Publish" value={d.pending_results} to="/admin/lms/results" />
          </>
        )}
      </div>
    </div>
  );
}
